import { render, staticRenderFns } from "./AccountSettingCompanySettings.vue?vue&type=template&id=272962eb&"
import script from "./AccountSettingCompanySettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettingCompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272962eb')) {
      api.createRecord('272962eb', component.options)
    } else {
      api.reload('272962eb', component.options)
    }
    module.hot.accept("./AccountSettingCompanySettings.vue?vue&type=template&id=272962eb&", function () {
      api.rerender('272962eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingCompanySettings.vue"
export default component.exports